export default __webpack_public_path__ + "static/media/card.720a18f8.png";